/**
 * BrandBD.tsx — Gold Garage Door / Brand section · B&D
 * Standalone brand section (navy). Logo + SEO copy + common fixes + CTA.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep <img> + inline SVG + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const NAVY2 = "#0f2347";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";
const LOGO = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp";
const FIXES = ["Controll-A-Door motor faults", "Panelift spring & cable repairs", "Roll-A-Door replacements", "Remote & keypad reprogramming", "Track & roller repairs", "New B&D door installs"];

/** check — DO NOT REPLACE WITH IMG */
const Check = () => <svg data-icon-container="lucide-do-not-replace" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{
  flexShrink: 0,
  marginTop: "3px"
}}><polyline points="20 6 9 17 4 12" /></svg>;
export default function BrandBD() {
  return <section id="brand-bd" style={{
    background: `radial-gradient(ellipse at 20% 0%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5rem",
    paddingBottom: "5rem"
  }}>
      <style>{`
        .br-grid { display: grid; grid-template-columns: 0.85fr 1.15fr; gap: 3rem; align-items: center; }
        .br-fixes { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem 1.25rem; }
        @media (max-width: 820px) {
          .br-grid { grid-template-columns: 1fr; gap: 1.75rem; }
          .br-fixes { grid-template-columns: 1fr; }
          #brand-bd { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-brand-bd"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-brand-bd)" /></svg>
      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      left: "-1rem",
      top: "6rem",
      fontSize: "11rem",
      fontWeight: 900,
      color: `${GOLD}0D`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>03</div>

      <div className="br-grid" style={{
      maxWidth: "1100px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        {/* logo panel */}
        <div style={{
        background: NAVY2,
        border: `1px solid ${GOLD}30`,
        borderRadius: "16px",
        padding: "2.5rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        minHeight: "200px",
        boxShadow: "none"
      }}>
          <img src={LOGO} alt="B&D garage doors and openers serviced by Gold Garage Door" width={180} height={60} loading="lazy" decoding="async" style={{
          maxHeight: "60px",
          maxWidth: "200px",
          width: "auto",
          objectFit: "contain",
          filter: "brightness(0) invert(1)",
          opacity: 0.9
        }} src="https://goldgaragedoor.com.au/wp-content/uploads/2026/06/b5706f1be_58dae4e4d_BD_Australia_Logo-removebg-preview.png" />
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.78rem",
          fontWeight: 700,
          color: GOLD,
          letterSpacing: "0.05em",
          textAlign: "center"
        }}>Australia's #1 residential brand</span>
        </div>

        {/* copy */}
        <div>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>Brand We Service</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.5rem, 5vw, 2.1rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.6rem 0 0.75rem"
        }}>B&D repairs & installs</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.98rem",
          color: "rgba(255,255,255,0.72)",
          lineHeight: 1.7,
          marginBottom: "1.5rem"
        }}>B&D is on more Sydney garages than any other brand. We service the full range — Panelift, Roll-A-Door and Firmadoor — plus B&D openers like the Controll-A-Door range, with genuine parts on the van.</p>

          <div className="br-fixes" style={{
          marginBottom: "1.75rem"
        }}>
            {FIXES.map((fx, j) => <div key={j} style={{
            display: "flex",
            gap: "0.6rem",
            alignItems: "flex-start"
          }}>
                <Check />
                <span style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.9rem",
              color: "rgba(255,255,255,0.85)",
              lineHeight: 1.4
            }}>{fx}</span>
              </div>)}
          </div>


          {/* Models we service — Current / Older (real model numbers for SEO) */}
          <div style={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid",
          borderColor: "rgba(255,255,255,0.1)",
          borderRadius: "14px",
          padding: "1.5rem",
          marginBottom: "1.75rem"
        }}>
            <div style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.72rem",
            fontWeight: 700,
            letterSpacing: "0.14em",
            color: GOLD,
            textTransform: "uppercase",
            marginBottom: "1rem"
          }}>Models We Service</div>
            <div style={{
            marginBottom: "1rem"
          }}>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "0.85rem",
              color: "#fff",
              marginBottom: "0.5rem"
            }}>Current range</div>
              <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.4rem"
            }}>
                {["Controll-A-Door Secure+", "Controll-A-Door 4 (CAD4)", "Controll-A-Door 5 (CAD5)", "Smart SDO-3 / SDO-4", "Diamond PDO"].map(mdl => <span key={mdl} style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.78rem",
                fontWeight: 600,
                color: "rgba(255,255,255,0.9)",
                background: "rgba(255,255,255,0.06)",
                border: "1px solid",
                borderColor: "rgba(255,255,255,0.14)",
                borderRadius: "999px",
                padding: "0.3rem 0.7rem"
              }}>{mdl}</span>)}
              </div>
            </div>
            <div>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700,
              fontSize: "0.85rem",
              color: "rgba(255,255,255,0.55)",
              marginBottom: "0.5rem"
            }}>Older / legacy models</div>
              <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.4rem"
            }}>
                {["Controll-A-Door A / B / C", "CAD-S / Secure", "Roll-A-Door", "Firmadoor openers", "TB6 / TB5 remotes"].map(mdl => <span key={mdl} style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.76rem",
                fontWeight: 500,
                color: "rgba(255,255,255,0.55)",
                background: "rgba(255,255,255,0.03)",
                borderRadius: "999px",
                padding: "0.28rem 0.65rem"
              }}>{mdl}</span>)}
              </div>
            </div>
          </div>

          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "0.875rem 1.75rem",
          background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
          color: NAVY,
          fontWeight: 700,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "0.95rem",
          boxShadow: `0 4px 20px ${GOLD}35`
        }}> Book a B&D job — 0485 000 933</a>
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>
    </section>;
}